import React from 'react';
import moment from 'moment';
import _ from 'lodash';

const Academy = ({academy}) => {
  return (
    <div className='text-secondary'>
    	<div className='flex items-center'>
	      <div className='mr2 flex-auto'>{academy.name.toUpperCase()}</div>
	      <div className='ml1'>{_.lowerCase(academy.type)}</div> 
      </div>
      <div className='pt1 h6'>{moment.utc(academy.createdAt).format('DD MMM YYYY h:mm A')}</div>
      <hr/>
    </div>
  );
};

export default Academy;



// WEBPACK FOOTER //
// ./src/views/dashboard/Academy.js